import * as mqtt from "mqtt/dist/mqtt.min";

const host = process.env.REACT_APP_RABBITMQ; // "204.236.174.105"; // "broker.emqx.io"" //"18.144.49.91"
const port = "15676"; //1883;
const protocol = "wss";
const MQTT_SERVER_URL = `${protocol}://${host}:${port}/ws`;
const MQTT_TOPIC = "backend-topic";
const clientId = "mqttjs_" + Math.random().toString(16).substr(2, 8);
const username = "test";
const password = "test1234";

const options = {
    username,
    password,
    // reconnectPeriod: 1000, // ms
    clientId,
};
let client = null;

export function initilizeRabbitConnection() {
    if (client) {
        return client;
    } else {
        client = mqtt.connect(MQTT_SERVER_URL, options);
        client.on("connect", () => {
            console.log("Connected to MQTT broker");
            const staffId = localStorage.getItem("x-dashboard-staffid");
            if (staffId) {
                client.subscribe(
                    `adn-broadcast-staff-${staffId}`,
                    { qos: 0 },
                    (err, res) => {
                        if (!err) {
                            // console.log(`Subscribed to topic: ${res}`);
                        }
                        // console.log("[Response]", res);
                    },
                );
            }
        });
        return client;
    }
}

export function disconnectMQTT() {
    console.log("disconnect called");
    client.end(true, {}, (data, err) => {
        console.log("disconnected");
    });
}
